<template>
  <v-dialog v-model="dialog" scrollable max-width="700px">
    <template v-slot:activator="{ on }">
      <a v-on="on" style="cursor: pointer; text-decoration: underline; color: #2196F3;">
        {{ linkText }}
      </a>
    </template>
    
    <v-card>
      <v-card-title class="headline primary white--text">
        <v-icon color="white" left>description</v-icon>
        Termos de Uso
      </v-card-title>
      
      <v-card-text style="height: 500px; padding: 24px;">
        <div class="termos-content">
          <p style="text-align: right;"><strong>Última atualização:</strong> 15 de outubro de 2025</p>

          <h3>1. ACEITAÇÃO DOS TERMOS</h3>
          <p>Ao acessar e usar esta plataforma, você concorda em cumprir e estar vinculado aos seguintes Termos de Uso. Se você não concordar com qualquer parte destes termos, não deverá utilizar nossa plataforma.</p>

          <h3>2. DESCRIÇÃO DO SERVIÇO</h3>
          <p>Esta é uma área exclusiva para clientes do Grupo Parque das Flores e suas empresas, oferecendo acesso a informações, documentos e serviços relacionados ao seu contrato.</p>

          <h3>3. CADASTRO E CONTA DE ACESSO</h3>
          <p>3.1. Para utilizar a plataforma, é necessário realizar um cadastro fornecendo informações verdadeiras, atuais e completas.</p>
          <p>3.2. Você é responsável por manter a confidencialidade de sua senha e por todas as atividades realizadas em sua conta.</p>
          <p>3.3. Notifique-nos imediatamente sobre qualquer uso não autorizado de sua conta.</p>
          <p>3.4. O Grupo Parque das Flores reserva-se o direito de recusar, suspender ou cancelar seu cadastro a qualquer momento.</p>

          <h3>4. USO ACEITÁVEL</h3>
          <p>4.1. Você concorda em usar a plataforma apenas para fins legais e de acordo com estes Termos de Uso.</p>
          <p>4.2. É proibido:</p>
          <ul>
            <li>Violar leis locais, estaduais, nacionais ou internacionais</li>
            <li>Transmitir material que seja ofensivo, difamatório ou ilegal</li>
            <li>Tentar obter acesso não autorizado a sistemas ou redes</li>
            <li>Interferir no funcionamento adequado da plataforma</li>
            <li>Utilizar a plataforma para fins comerciais não autorizados</li>
            <li>Copiar, reproduzir ou distribuir conteúdo sem autorização prévia</li>
          </ul>

          <h3>5. PROPRIEDADE INTELECTUAL</h3>
          <p>5.1. Todo o conteúdo da plataforma, incluindo textos, gráficos, logotipos, imagens, áudios, vídeos e software, é de propriedade do Grupo Parque das Flores ou de seus licenciadores.</p>
          <p>5.2. É proibida a reprodução, distribuição ou modificação de qualquer conteúdo sem autorização expressa.</p>

          <h3>6. PRIVACIDADE E PROTEÇÃO DE DADOS</h3>
          <p>6.1. A coleta e uso de suas informações pessoais estão sujeitos à nossa Política de Privacidade.</p>
          <p>6.2. Ao usar a plataforma, você consente com a coleta, uso e compartilhamento de suas informações conforme descrito na Política de Privacidade.</p>
          <p>6.3. Nos comprometemos a proteger seus dados pessoais de acordo com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018).</p>

          <h3>7. DISPONIBILIDADE DO SERVIÇO</h3>
          <p>7.1. Embora nos esforcemos para manter a plataforma disponível 24 horas por dia, 7 dias por semana, não garantimos que o acesso será ininterrupto ou livre de erros.</p>
          <p>7.2. Reservamo-nos o direito de modificar, suspender ou descontinuar a plataforma a qualquer momento, sem aviso prévio.</p>

          <h3>8. LIMITAÇÃO DE RESPONSABILIDADE</h3>
          <p>8.1. A plataforma é fornecida "como está" e "conforme disponível", sem garantias de qualquer tipo.</p>
          <p>8.2. O Grupo Parque das Flores não se responsabiliza por danos diretos, indiretos, incidentais ou consequentes.</p>

          <h3>9. LEI APLICÁVEL E FORO</h3>
          <p>9.1. Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil.</p>
          <p>9.2. Qualquer disputa decorrente destes termos será submetida ao foro da comarca da sede do Grupo Parque das Flores.</p>

          <h3>10. CONTATO</h3>
          <p>Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco:</p>
          <p><strong>Grupo Parque das Flores</strong><br>
          E-mail: dpo@grupoparque.com.br</p>
        </div>
      </v-card-text>
      
      <v-divider></v-divider>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TermosDeUso',
  props: {
    linkText: {
      type: String,
      default: 'Termos de Uso'
    }
  },
  data() {
    return {
      dialog: false
    }
  }
}
</script>

<style scoped>
.termos-content {
  font-size: 14px;
  line-height: 1.6;
}

.termos-content h3 {
  color: #3e6ba2;
  font-size: 16px;
  font-weight: bold;
  margin-top: 24px;
  margin-bottom: 12px;
}

.termos-content p {
  margin-bottom: 12px;
  text-align: justify;
}

.termos-content ul {
  margin-left: 20px;
  margin-bottom: 12px;
}

.termos-content li {
  margin-bottom: 8px;
}
</style>

